import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Particle from "../Particle";
import Github from "./Github";
import Techstack from "./Techstack";
import Aboutcard from "./AboutCard";
import laptopImg from "../../assets/about.png";
import Toolstack from "./Toolstack";

function About() {
  return (
    <Container fluid className="about-section">
      <Particle />

      <Container>
        {/* About Me Section */}
        <Row
          style={{
            justifyContent: "center",
            alignItems: "center",
            padding: "10px",
          }}
        >
          <Col
            md={7}
            style={{
              justifyContent: "center",
              paddingTop: "30px",
              paddingBottom: "50px",
            }}
          >
            <h1
              style={{
                fontSize: "2.1em",
                paddingBottom: "20px",
              }}
            >
              Know Who <strong className="purple">I'M</strong>
            </h1>

            <Aboutcard />
          </Col>

          <Col
            md={5}
            style={{
              paddingTop: "50px",
              paddingBottom: "50px",
              textAlign: "center",
            }}
            className="about-img"
          >
            <img
              src={laptopImg}
              alt="Unique Tandukar working on technology"
              className="img-fluid"
            />
          </Col>
        </Row>

        {/* Professional Skillset */}
        <h1 className="project-heading">
          Professional <strong className="purple">Skillset</strong>
        </h1>

        <Techstack />

        {/* Tools Section */}
        <h1 className="project-heading">
          <strong className="purple">Tools</strong> I Use
        </h1>

        <Toolstack />

        {/* GitHub Section */}
        <Github />
      </Container>
    </Container>
  );
}

export default About;